app.controller(
    'AdminUserRoleController', ['$scope', AdminUserRoleController]
);

function AdminUserRoleController($scope) {

    $scope.roleLang = [
        {
            name: 'Traducteur',
            openTranslation: true
        },
        {
            name: 'Administrateur',
            openTranslation: false
        },
        {
            name: 'Correcteur',
            openTranslation: false
        },
        {
            name: 'Secrétaire de rédaction',
            openTranslation: false
        }
    ];
}